import CWTracks from '@channelwill/tracks';
import { CHANNELWILL_APP_ID } from '@/constants/app';
import { getChannelwillSign } from '@/lib/track/get-sign';

export function initCWTracks(storeName = '') {
  const dsn = `${process.env.PUBLIC_CHANNELWILL_DSN}/affiliate/v1/report/bind`;
  CWTracks.init({
    dsn,
    appStoreUrl: 'https://apps.shopify.com/loloyal',
    getAuthSignature: getChannelwillSign,
    app_id: CHANNELWILL_APP_ID,
    shop: storeName
  });
}
